
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { functions } from '@/firebase';
import { SNACKBAR_STATUS } from '@/constants/constants';
import RunnitMenuOrBottomSheet from '@/views/Runnits/base/RunnitMenuOrBottomSheet.vue';
import ComplexBackgroundSettingMenu from '@/components/designElements/ComplexBackgroundSettingMenus.vue';
import { extractPromptStringValue, RUNNIT_NODE_FIELD_TYPE } from '@run-diffusion/shared';
import _trim from 'lodash/trim';

export default Vue.extend({
	name: 'PromptGenerator',
	props: {
		isOpen: { type: Boolean, default: false },
		promptValue: { type: [String, Object], default: null },
		promptField: { type: Object, required: true },
	},
	data () {
		return {
			loadingPrompts: false,

			generatedPrompts: [],
			errorGeneratingPrompts: false,
			RUNNIT_NODE_FIELD_TYPE,
		};
	},
	watch: {
		'$store.state.triggers.fireInitialPromptGenerationTrigger': {
			immediate: false,
			async handler (newVal: number, oldVal: number) {
				if (
					newVal &&
					newVal !== oldVal &&
					!this.generatedPrompts.length &&
					_trim(this.promptStringValue)
				) {
					await this.onClickGeneratePrompts();
				}
			},
		},
	},
	computed: {
		...mapState([
			'runnitState',
		]),
		promptStringValue (): string {
			return (extractPromptStringValue(this.promptValue) || '').trim();
		},
		hasNegPromptField (): boolean {
			return !!this.runnitState?.fieldsByType?.[RUNNIT_NODE_FIELD_TYPE.NEG_PROMPT]?.length;
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
			'updateRunnitState',
		]),
		onClose () {
			this.$emit('close');
			this.updateRunnitState({
				promptGeneratorOpen: false,
			});
		},
		onUseEnhancedPromptClick (positive: string, negative: string) {
			this.$emit('on-use-enhanced-prompt', positive, negative);
			this.onClose();
		},
		async onClickGeneratePrompts () {
			this.generatedPrompts = [];
			this.errorGeneratingPrompts = false;
			this.loadingPrompts = true;
			try {
				const functionRef = functions
					.httpsCallable('promptMaker');
				const { success, generations, error } = (await functionRef({
					prompt: this.promptStringValue,
					numGenerations: 2,
				})).data;

				if (success && generations && generations.length) {
					this.generatedPrompts = generations;
				} else if (!success) {
					this.errorGeneratingPrompts = true;
				}
			} catch (e) {
				console.error(e);
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'Error enhancing prompt, please try again',
					show: true,
				});
				this.loadingPrompts = false;
				this.errorGeneratingPrompts = true;
			} finally {
				this.loadingPrompts = false;
			}
		},
	},
	components: {
		RunnitMenuOrBottomSheet,
		ComplexBackgroundSettingMenu,
	},
});
